// extracted by mini-css-extract-plugin
export default {"WixStudioTemplateSidePanel":"w355RB","wixStudioTemplateSidePanel":"w355RB"};